import {FormSectionType} from '../../../../../../blocks/FormBlock'
import box from '../../fields/box'
import city from '../../fields/city'
import func from '../../fields/func'
import houseNumber from '../../fields/houseNumber'
import sameAsClientData from '../../fields/sameAsClientData'
import street from '../../fields/street'
import zip from '../../fields/zip'
import defaultPersonalData from '../personal/personalData'

const personalData: FormSectionType = {
	...defaultPersonalData,
	fields: [
		...defaultPersonalData.fields,
		func,
		sameAsClientData,
		street,
		houseNumber,
		box,
		zip,
		city
	].map((field) => {
		return {...field, parent_id: 1}
	})
}

export default personalData
